/**
 * WealthOak sells memberships, not goods, so the goods features are hidden from the screens: inventory and its stock,
 * challans, packages, receives, serials and batches, bins, kits and vendor returns, extra locations (warehouses and
 * branches), stock reports, e-way bills and TCS. The code stays; set this to false to show them again.
 */
export const GOODS_HIDDEN = true;

/**
 * The extras WealthOak does not use are hidden the same way: sales orders, purchase orders, price books, currencies other
 * than the rupee, the vendor portal, more than one organization (new ones, consolidated reports, inter-company), projects
 * and timesheets, pricing widgets, custom modules and e-invoices. Set this to false to show them again.
 */
export const EXTRAS_HIDDEN = true;

/** The menu entries those extras have. */
export const HIDDEN_VIEWS: ReadonlySet<string> = new Set(EXTRAS_HIDDEN ? ["salesorders", "projects", "vendorportal", "modules"] : []);
